import { httpClientInterface } from 'app-components/utils/core';
import { getServiceUrl } from 'app-components/utils/core/interfaces/httpClientInterface';

export type AiChatFeedbackType = 'POSITIVE' | 'NEGATIVE';

export type SubmitAiChatFeedbackArgs = {
  conversationId: string;
  conversationItemId?: string;
  type: AiChatFeedbackType;
  text?: string;
  reasons?: readonly string[];
};

/** Submit feedback for an assistant message. The gateway returns 204 with no body. */
export const submitAiChatFeedback = async ({
  conversationId,
  conversationItemId,
  type,
  text,
  reasons,
}: SubmitAiChatFeedbackArgs): Promise<void> => {
  const trimmedText = text?.trim();
  const url = `${getServiceUrl()}/llm/v1/conversations/${encodeURIComponent(conversationId)}/feedback`;
  // Streamed responses use temporary client UUIDs; historical items use persisted numeric gateway IDs.
  const persistedItemId = conversationItemId && /^\d+$/.test(conversationItemId) ? conversationItemId : undefined;
  const metadata = {
    ...(persistedItemId ? { conversationItemIds: [persistedItemId] } : {}),
    ...(conversationItemId && !persistedItemId ? { clientMessageId: conversationItemId } : {}),
    ...(reasons?.length ? { reasons: [...reasons] } : {}),
  };
  const payload = {
    type,
    ...(trimmedText ? { text: trimmedText } : {}),
    ...(Object.keys(metadata).length ? { metadata } : {}),
  };

  await httpClientInterface.send('POST', url, payload);
};
